"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentRateResponseWithCount = exports.mockedFulfillmentRateResponse = exports.mockedFulfillmentRateUpdateRequest = exports.mockedFulfillmentRateCreateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const date_util_1 = require("../../utils/date.util");
const country_1 = require("../country");
const fulfillment_1 = require("../fulfillment");
const fulfillment_delivery_method_1 = require("../fulfillment-delivery-method");
exports.mockedFulfillmentRateCreateRequest = {
  fulfillmentId: 1,
  countryId: 1,
  deliveryMethodId: 1,
  price: 50.54,
  priceCurrency: common_interfaces_1.Currency.dollar,
  weightFrom: 501,
  weightTo: 1000
};
exports.mockedFulfillmentRateUpdateRequest = {
  countryId: 2,
  price: 68.57
};
exports.mockedFulfillmentRateResponse = {
  id: 1,
  fulfillment: fulfillment_1.mockedFulfillmentResponse,
  country: country_1.mockedCountryResponse,
  deliveryMethod: fulfillment_delivery_method_1.mockedFulfillmentDeliveryMethodResponse,
  price: 50.54,
  priceCurrency: common_interfaces_1.Currency.dollar,
  weightFrom: 501,
  weightTo: 1000,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedFulfillmentRateResponseWithCount = {
  items: [exports.mockedFulfillmentRateResponse],
  count: 1
};